import { isEmbeddedConfluence_DO_NOT_USE } from '@atlassian/embedded-confluence/isEmbeddedConfluence';

import { useEmbeddedEditPageFeatures } from '../edit-page/useEmbeddedEditPageFeatures.ts';
import { useEmbeddedViewPageFeatures } from '../view-page/useEmbeddedViewPageFeatures.ts';

export const useEmbeddedComments = () => {
	const isEmbeddedConfluence = isEmbeddedConfluence_DO_NOT_USE();

	const {
		hasComments: hasPageComments,
		hasInlineCommentsAndHighlightActions: hasViewInlineComments,
	} = useEmbeddedViewPageFeatures();
	const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } =
		useEmbeddedEditPageFeatures();

	if (!isEmbeddedConfluence) {
		return true;
	}

	const allowPageCommentsInEmbeddedMode = hasPageComments;
	const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;

	return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
